export function selectTwo() {
  $(document).ready(function () {
    $("select").select2({
      minimumResultsForSearch: -1,
    });

    $("select").on("select2:select", function (e) {
      var select = $(e.currentTarget);

      if (select.closest('#video-orderby').length) {
        window.location = select.val()
      }
    });
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/selectTwo.js